export default "__VITE_ASSET__b4d0aa5b__"